export default __webpack_public_path__ + "static/media/6.413f51c3.svg";